import { useEffect, useState } from "react";
import { Button } from "components/ui/button";
import { WidgetEditor } from "./WidgetEditor";
import { useGetTemplatesData } from "hooks/templates";
import { useAddPages, usePageDetailData } from "hooks/pages";
import { useNotificationBar } from "context/notificationContext";
import { getErrorResponse } from "services/util";
import { useNavigate, useParams } from "react-router-dom";

const PAGE_TYPE_OPTIONS = [
  { id: 1, name: "Home" },
  { id: 2, name: "Category" },
  { id: 3, name: "Episode" },
  { id: 4, name: "Collection" },
  { id: 5, name: "Show" },
];

const a = {
  "widgets": [
    {
      "uid": "bW22-7YvUD-VBmYQTWnB_k",
      "widget_id": 2,
      "widget_name": "Hero-widget",
      "widget_code": "HW",
      "widget_data": {
        "widget_title": "Hottest topics",
        "widget_icon": "<icon url>",
        "view_all": true,
        "redirection_to": "SHOW/CATEGORY/COLLECTION/EPISODE",
        "redirection_id": "",
        "widget_items": [
          {
            "title": "Master Content Creation",
            "thumbnail": "<thumbnail url>",
            "redirection_to": "SHOW/CATEGORY/COLLECTION/EPISODE",
            "redirection_id": ""
          }
        ]
      }
    },
    {
      "uid": "bW22-7YvUD-VBmYQTWnB_",
      "widget_id": 3,
      "widget_name": "Video Coursel",
      "widget_code": "VC",
      "widget_data": {
        "widget_title": "Money Management Creator",
        "widget_icon": "<icon url>",
        "view_all": true,
        "redirection_to": "SHOW/CATEGORY/COLLECTION/EPISODE",
        "redirection_id": "",
        "widget_items": [
          {
            "title": "Master Content Creation",
            "thumbnail": "<thumbnail url>",
            "redirection_to": "SHOW/CATEGORY/COLLECTION/EPISODE",
            "redirection_id": ""
          }
        ]
      }
    }
  ]
}


export const AddUpdatePages = ({ mode }: { mode: 'create' | 'edit' }) => {
  const [pageName, setPageName] = useState("");
  const [pageDescription, setPageDescription] = useState("");
  const [selectedTemplateId, setSelectedTemplateId] = useState<number>();
  const [selectPageTypeId, setSelectPageTypeId] = useState<number | "">("");
  const [pageWidgets, setPageWidgets] = useState([]);
  const [activeWidget, setActiveWidget] = useState<any>(null);
  const [isActive, setIsActive] = useState(false);
  const params = useParams()

  const { data } = useGetTemplatesData()
  const { mutate: addPages } = useAddPages()
  const { data: pageData, isFetching: loadingPage } = usePageDetailData(
    params.id,
    { enabled: !!params.id }
  )

  useEffect(() => {

    if (pageData?.data) {
      setSelectedTemplateId(pageData.data?.template_id)
      setSelectPageTypeId(3)
      setActiveWidget(null)
      setPageName(pageData?.data?.title)
      setPageWidgets(pageData?.data?.page_data?.widgets)

    }


  }, [pageData?.data])


  const notification = useNotificationBar()
  const navigate = useNavigate();

  const handleTemplateSelect = (templateId: number) => {
    setSelectedTemplateId(templateId);
    const template = data?.data.find(
      (t) => t.id === templateId
    );

    if (!template) return;
    const widgetsForPage = template.data.map((w: any) => ({
      uid: w.uid,
      widget_id: w.data.id,
      widget_name: w.data?.name ?? '',
      widget_code: w.data?.code ?? '',
    }));

    setPageWidgets(widgetsForPage);
  };

  const handleWidgetDataChange = (updatedWidget: any) => {
    setPageWidgets((prev: any) =>
      prev.map((w) =>
        w.uid === updatedWidget.uid
          ? {
            ...w,
            ...updatedWidget,
          }
          : w
      )
    );
    setActiveWidget(null)
  };

  const handleSavePage = () => {
    const selectedPageTypeName = PAGE_TYPE_OPTIONS.find(
      (p) => p.id === selectPageTypeId
    )?.name;
    const sections = pageWidgets.map((w: any) => ({
      ...w,
    }));
    console.log(sections)
    const data = {
      title: pageName,
      description: pageDescription,
      template_id: selectedTemplateId,
      page_type: selectedPageTypeName,
      is_default: 0,
      page_data: { widgets: sections },
      status: isActive ? 1 : 0
    };
    addPages(
      { data },
      {
        onError(error: any) {
          notification.push(getErrorResponse(error))
        },
        onSuccess(data, variables, context) {
          notification.push({
            title: 'Success !',
            message: 'Page has been created successfully !',
            type: 'success'
          })
          // onSubmitHandler && onSubmitHandler(data);
          navigate('/pages/page-management');

        },
      }
    )
  };

  return (
    <div className="h-[85vh] flex flex-col gap-4">

      {/* TOP BAR — CREATE PAGE */}
      <div className="bg-white dark:bg-slate-800 border border-gray-300 dark:border-gray-600 rounded-lg p-4 shadow-sm">
        <div className="flex items-center justify-between gap-4">

          <h2 className="text-xl font-semibold whitespace-nowrap dark:text-white">
            Create Page
          </h2>

          <input
            value={pageName}
            onChange={(e) => setPageName(e.target.value)}
            placeholder="Page Name"
            className="flex-1 max-w-sm px-3 py-2 border rounded dark:bg-slate-700 dark:text-white"
          />
          <input
            value={pageDescription}
            onChange={(e) => setPageDescription(e.target.value)}
            placeholder="Page Description"
            className="flex-1 max-w-sm px-3 py-2 border rounded dark:bg-slate-700 dark:text-white"
          />

          <select
            value={selectPageTypeId}
            onChange={(e) => setSelectPageTypeId(Number(e.target.value))}
            className="px-3 py-2 border rounded dark:bg-slate-700 dark:text-white"
          >
            <option value="">Page Type</option>

            {PAGE_TYPE_OPTIONS.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </select>


          <select
            value={selectedTemplateId ?? ""}
            onChange={(e) => handleTemplateSelect(Number(e.target.value))}
            className="px-3 py-2 border rounded dark:bg-slate-700 dark:text-white"
          >
            <option value="">Select Template</option>
            {data?.data?.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </select>
          <button
            onClick={() => setIsActive(!isActive)}
            className={`w-10 h-5 rounded-full p-1 transition ${isActive ? "bg-blue-600" : "bg-gray-300"
              }`}
          >
            <div
              className={`h-3 w-3 rounded-full bg-white transform transition ${isActive ? "translate-x-5" : "translate-x-0"
                }`}
            />
          </button>
          <Button
            color="blue"
            disabled={!pageName || !selectedTemplateId || !selectPageTypeId || !pageDescription}
            onClick={handleSavePage}
          >
            Save Page
          </Button>
        </div>
      </div>

      {/* BOTTOM WORK AREA */}
      <div className="flex flex-1 gap-4 overflow-hidden">

        {/* LEFT — WIDGET LIST */}
        <div className="w-[20%] min-w-[260px] bg-white border rounded-lg p-4 overflow-y-auto">
          <h3 className="font-semibold mb-3">Widgets</h3>

          {pageWidgets?.length === 0 && (
            <p className="text-sm text-gray-500">
              Select a template to load widgets
            </p>
          )}

          <div className="space-y-2">
            {pageWidgets?.map((w: any, i) => {
              const isActive =
                activeWidget?.uid === w.uid;

              return (
                <div
                  key={w.uid}
                  className={`
                    flex items-center justify-between
                    rounded p-3 transition-all dark:bg-slate-700 dark:text-white border border-gray-300 dark:border-gray-600
                    ${isActive
                      ? "border-2 border-blue-500 bg-blue-50"
                      : "border border-gray-200 bg-white hover:bg-gray-50"
                    }
                  `}
                >
                  <span
                    className={
                      isActive ? "font-semibold text-blue-700" : ""
                    }
                  >
                    {w.widget_name}
                  </span>

                  <button
                    onClick={() => setActiveWidget(w)}
                    className={`
                      text-sm px-3 py-1.5 rounded-md font-medium
                      ${isActive
                        ? "text-blue-700 bg-blue-100 cursor-default"
                        : "text-blue-700 bg-blue-100 hover:bg-blue-50"
                      }
                    `}
                  >
                    {isActive ? "Editing" : "Edit"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* RIGHT — WIDGET CONFIG (WIDER) */}
        <div className="flex-1 bg-white dark:bg-slate-800 border border-gray-300 dark:border-gray-600 rounded-lg p-4 overflow-y-auto">
          <h3 className="font-semibold mb-3 dark:text-white">Widget Configuration</h3>

          {!activeWidget && (
            <p className="text-sm text-gray-500">
              Select a widget to edit
            </p>
          )}

          {activeWidget && (
            <WidgetEditor
              widget={activeWidget}
              onChange={handleWidgetDataChange}
            />
          )}
        </div>

      </div>
    </div>
  );
};

